module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('form', {
    staticClass: "form smart-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.firstName),
      expression: "datosPerfil.firstName"
    }],
    ref: "firstName",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.firstName,
      "value": (_vm.datosPerfil.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPerfil.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosPerfil.firstName.required) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre no puede estar vacío")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.lastName),
      expression: "datosPerfil.lastName"
    }],
    ref: "lastName",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.lastName,
      "value": (_vm.datosPerfil.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPerfil.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosPerfil.lastName.required) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El apellido no puede estar vacío")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "mail",
      "disabled": ""
    },
    domProps: {
      "value": _vm.user.email
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.telefono),
      expression: "datosPerfil.telefono"
    }],
    ref: "telefono",
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.user.telefono,
      "value": (_vm.datosPerfil.telefono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPerfil.telefono = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Empresa")]), _vm._v(" "), (_vm.user.roles[0] === 'user' || _vm.user.roles[0] === 'admincliente') ? [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.user.sucursalAsociada.empresa.razonSocial + '-' + _vm.user.sucursalAsociada.denominacion
    }
  })] : _vm._e(), _vm._v(" "), (_vm.user.roles[0] === 'restaurante') ? [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.user.proveedorAsociado.razonSocial
    }
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_vm._v("+549")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.telefonoCelular),
      expression: "datosPerfil.telefonoCelular"
    }],
    ref: "telefonoCelular",
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "autocomplete": "off",
      "name": "telefonoCelular",
      "id": "telefonoCelular"
    },
    domProps: {
      "value": _vm.user.telefonoCelular,
      "value": (_vm.datosPerfil.telefonoCelular)
    },
    on: {
      "change": function($event) {
        _vm.clearUniqueCellphone()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPerfil.telefonoCelular = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), (!_vm.$v.datosPerfil.telefonoCelular.cellphone) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El número es incorrecto")]) : _vm._e(), _vm._v(" "), (_vm.errorCellphoneUnique) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El número ya está registrado por otro usuario")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.aceptaMailing),
      expression: "datosPerfil.aceptaMailing"
    }],
    attrs: {
      "type": "checkbox",
      "name": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPerfil.aceptaMailing) ? _vm._i(_vm.datosPerfil.aceptaMailing, null) > -1 : (_vm.datosPerfil.aceptaMailing)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPerfil.aceptaMailing,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPerfil.aceptaMailing = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPerfil.aceptaMailing = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPerfil.aceptaMailing = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Recibir notificaciones y ofertas a mi correo")])])]), _vm._v(" "), (_vm.user.telefonoCelular) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.notificarWhatsapp),
      expression: "datosPerfil.notificarWhatsapp"
    }],
    attrs: {
      "type": "checkbox",
      "name": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPerfil.notificarWhatsapp) ? _vm._i(_vm.datosPerfil.notificarWhatsapp, null) > -1 : (_vm.datosPerfil.notificarWhatsapp)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPerfil.notificarWhatsapp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPerfil.notificarWhatsapp = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPerfil.notificarWhatsapp = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPerfil.notificarWhatsapp = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Deseo recibir el menú del día a través de Whatsapp")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear-xs"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 form-group"
  }, [_c('h3', {
    staticClass: "title-label"
  }, [_vm._v("RESTRICCIONES ALIMENTARIAS")]), _vm._v(" "), _c('div', {
    staticClass: "inline-group margin-top-10"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.celiac),
      expression: "datosPerfil.celiac"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPerfil.celiac) ? _vm._i(_vm.datosPerfil.celiac, null) > -1 : (_vm.datosPerfil.celiac)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPerfil.celiac,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPerfil.celiac = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPerfil.celiac = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPerfil.celiac = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Sin Gluten")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.vegetarian),
      expression: "datosPerfil.vegetarian"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPerfil.vegetarian) ? _vm._i(_vm.datosPerfil.vegetarian, null) > -1 : (_vm.datosPerfil.vegetarian)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPerfil.vegetarian,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPerfil.vegetarian = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPerfil.vegetarian = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPerfil.vegetarian = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Vegetariano")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.vegan),
      expression: "datosPerfil.vegan"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPerfil.vegan) ? _vm._i(_vm.datosPerfil.vegan, null) > -1 : (_vm.datosPerfil.vegan)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPerfil.vegan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPerfil.vegan = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPerfil.vegan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPerfil.vegan = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Vegano")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.alergic),
      expression: "datosPerfil.alergic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPerfil.alergic) ? _vm._i(_vm.datosPerfil.alergic, null) > -1 : (_vm.datosPerfil.alergic)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPerfil.alergic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPerfil.alergic = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPerfil.alergic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPerfil.alergic = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Alergico")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.other),
      expression: "datosPerfil.other"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datosPerfil.other) ? _vm._i(_vm.datosPerfil.other, null) > -1 : (_vm.datosPerfil.other)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.datosPerfil.other,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.datosPerfil.other = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.datosPerfil.other = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.datosPerfil.other = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v("Otro")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.datosPerfil.alergic || _vm.datosPerfil.other),
      expression: "datosPerfil.alergic||datosPerfil.other"
    }],
    staticClass: "col-xs-12 form-group"
  }, [_c('label', [_vm._v("DETALLE")]), _vm._v(" "), _c('div', {
    staticClass: "textarea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosPerfil.restrictions),
      expression: "datosPerfil.restrictions"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validateRestrictions),
      expression: "validateRestrictions"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "Por favor describe sencillamente tus restricciones alimenticias..."
    },
    domProps: {
      "value": (_vm.datosPerfil.restrictions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosPerfil.restrictions = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosPerfil.restrictions && (_vm.$v.datosPerfil.other || _vm.$v.datosPerfil.alergic)) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("La descripción no puede estar vacía")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "disabled": !!_vm.$v.datosPerfil.$invalid
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cambiarDatos($event)
      }
    }
  }, [_vm._v("Cambiar datos")])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.erroresCambioPassword.length > 0) ? _c('div', {
    staticClass: "box-error"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.erroresCambioPassword), function(error) {
    return _c('li', [_vm._v(_vm._s(error.message))])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Contraseña actual")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosLogin.password),
      expression: "datosLogin.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.datosLogin.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosLogin.password = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosLogin.password.minLength && _vm.mostrarErroresLogin) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe contener por lo menos 6 caracteres")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nueva contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosLogin.nuevoPassword),
      expression: "datosLogin.nuevoPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.datosLogin.nuevoPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosLogin.nuevoPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosLogin.nuevoPassword.minLength && _vm.mostrarErroresLogin) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe contener por lo menos 6 caracteres")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Repetir nueva contraseña")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datosLogin.repetirNuevo),
      expression: "datosLogin.repetirNuevo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.datosLogin.repetirNuevo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.datosLogin.repetirNuevo = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.datosLogin.repetirNuevo.sameAs && _vm.mostrarErroresLogin) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Debe coincidir con el password")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cambiarPassword($event)
      }
    }
  }, [_vm._v("Cambiar contraseña")])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h2', [_vm._v("PERFIL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Teléfono Celular "), _c('small', [_vm._v("Código de área sin 0 y sin 15")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header subline-top"
  }, [_c('h2', [_vm._v("CONTRASEÑA")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7119c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/Perfil.vue
// module id = 1107
// module chunks = 5